<template>
  <div ref="widgetRef" class="articles-list grid">
    <div class="wrapper">
      <ArticleFilters :filters="filters" :tags="widget.all_available_tags" />
      <ArticleGrid
        :loading="articlesPending"
        :articles="articles?.results ?? []"
      />
      <ArticlePagination
        :page-count="pageCount"
        :filters="filters"
        @change="handlePageChange"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useArticleFilters } from '@/composables/useArticleFilters'
import type { PublicArticleListWidget } from '@/service/__generated-api'
import type { Widget } from '@/types/utils'

defineProps<Widget<PublicArticleListWidget>>()

const filters = useArticleFilters('blog')

const listQuery = computed(() => ({
  page_size: 6,
  page: filters.page.value,
  tags: filters.selectedTags.value
}))

const { data: articles, pending: articlesPending } = await useAsyncData(
  'articles-list',
  async () => useApi().publicPagesArticlesList(listQuery.value),
  {
    watch: [listQuery]
  }
)

const pageCount = computed(() => {
  if (!articles.value?.count || !articles.value.page_size) return 1
  return Math.ceil(articles.value.count / articles.value.page_size)
})

const widgetRef = ref<HTMLElement>()

const handlePageChange = () => {
  if (!widgetRef.value) return
  const rootStyles = getComputedStyle(document.body)
  const rootFontSize = parseFloat(rootStyles.fontSize)
  const rootNavHeight = parseFloat(
    rootStyles.getPropertyValue('--nav-height').replace('rem', '')
  )
  const height = rootNavHeight * rootFontSize
  window.scrollTo({
    top: widgetRef.value.getBoundingClientRect().top + window.scrollY - height
  })
}
</script>

<style lang="scss">
.wrapper {
  @include column(xs, 12);
}
</style>
